import {SERVICE_NAMES} from '../constants';
import {createApiCall} from '../utils';
import type {ServiceName} from '../constants';
import type {
    ApiCallOptions,
    ReminderSchedulesResponse,
    ReminderScheduleRequest,
    ReminderScheduleView,
    NotificationView,
    NotificationRequest
} from './api.d';

const createReminderApiCall = <T = any>(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
    endpoint: string
) => createApiCall<T>(SERVICE_NAMES.REMINDER as ServiceName, method, endpoint);

export const reminderApi = {
    getSchedules: (
        transactionId: string,
        options?: ApiCallOptions
    ) => createReminderApiCall<ReminderSchedulesResponse>(
        'GET',
        `transactions/${transactionId}/schedules`
    )({...options}),

    createOrUpdateSchedule: (
        transactionId: string,
        data: ReminderScheduleRequest,
        options?: ApiCallOptions
    ) => createReminderApiCall<{data: ReminderScheduleView}>(
        'PUT',
        `transactions/${transactionId}/schedules`
    )({...options, data}),

    deleteSchedule: (
        transactionId: string,
        options?: ApiCallOptions
    ) => createReminderApiCall<void>(
        'DELETE',
        `transactions/${transactionId}/schedules`
    )({...options}),

    sendNotification: (
        transactionId: string,
        recipientId: string,
        options?: ApiCallOptions
    ) => createReminderApiCall<{data: NotificationView}>(
        'POST',
        `transactions/${transactionId}/recipients/${recipientId}/notifications`
    )({...options}),

    sendNotifications: (
        transactionId: string,
        data?: NotificationRequest,
        options?: ApiCallOptions
    ) => createReminderApiCall<{data: NotificationView[]}>(
        'POST',
        `transactions/${transactionId}/notifications`
    )({...options, data})
};
